import { createReducer, on } from '@ngrx/store';
import { initialPlatformState } from './platform_state';
import {
  updateMaxMonthlyOrders,
  updatePhone,
  updatePlatform,
  updatePopover,
  updateSaving,
  updateWebsite,
  updateWebsiteInvalid
} from './platform_actions_creator';

export const platformReducer = createReducer(
  initialPlatformState,
  on(updatePlatform, (state, action) => ({...state, platform: action.platform})),
  on(updateWebsite, (state, action) => ({...state, website: action.website})),
  on(updateWebsiteInvalid, (state, action) => ({...state, website_invalid: action.website_invalid})),
  on(updateMaxMonthlyOrders, (state, action) => ({...state, maxMonthlyOrders: action.maxMonthlyOrders})),
  on(updatePhone, (state, action) => ({...state, phone: action.phone})),
  on(updateSaving, (state, action) => ({...state, saving: action.saving})),
  on(updatePopover, (state, action) => ({...state, popover: action.popover})),
);
